import { getUserByUID, validateUserStatusAndRole } from '@/services/usersService'

/** Códigos de acceso expuestos a login / force logout (sin detalle técnico en UI). */
export const USER_ACCESS_REASONS = {
  INACTIVE: 'inactive',
  NOT_FOUND: 'not_found',
  INVALID_ROLE: 'invalid_role',
  INVALID: 'invalid',
}

/** @deprecated Usar USER_ACCESS_REASONS */
export const SESSION_INVALID_REASONS = USER_ACCESS_REASONS

const LEGACY_REASON_MAP = {
  deleted: USER_ACCESS_REASONS.NOT_FOUND,
}

/**
 * Mensaje amigable para el usuario según reason (sin detalles internos).
 * @param {string} [reason]
 * @returns {string}
 */
export const getUserAccessMessage = reason => {
  const normalized = LEGACY_REASON_MAP[reason] || reason

  switch (normalized) {
    case USER_ACCESS_REASONS.INACTIVE:
      return 'Tu cuenta ha sido inhabilitada. Ponte en contacto con el administrador.'
    case USER_ACCESS_REASONS.NOT_FOUND:
      return 'No tienes acceso al backoffice. Ponte en contacto con el administrador.'
    case USER_ACCESS_REASONS.INVALID_ROLE:
      return 'No tienes permiso para acceder. Ponte en contacto con el administrador.'
    default:
      return 'No tienes acceso al backoffice. Ponte en contacto con el administrador.'
  }
}

/** @deprecated Usar getUserAccessMessage */
export const getSessionLogoutMessage = reason => getUserAccessMessage(reason)

/**
 * @param {Object} userData
 * @returns {{ valid: false, reason: string, internalDetail?: string } | { valid: true, userData: Object }}
 */
export const evaluateUserSessionFromRTDB = userData => {
  if (!userData) {
    return {
      valid: false,
      reason: USER_ACCESS_REASONS.NOT_FOUND,
      internalDetail: 'userData missing',
    }
  }

  const validation = validateUserStatusAndRole(userData)
  if (!validation.valid) {
    return {
      valid: false,
      reason: validation.reason || USER_ACCESS_REASONS.INVALID,
      internalDetail: validation.internalDetail,
    }
  }

  return {
    valid: true,
    userData,
  }
}

/**
 * Valida la sesión actual contra RTDB (existencia, status activo, rol permitido).
 * @param {string} uid
 * @returns {Promise<{ valid: boolean, reason?: string, internalDetail?: string, userData?: Object }>}
 */
export const validateSessionAgainstRTDB = async uid => {
  if (!uid) {
    return {
      valid: false,
      reason: USER_ACCESS_REASONS.INVALID,
      internalDetail: 'missing uid in session',
    }
  }

  const userResult = await getUserByUID(uid)
  if (!userResult.success || !userResult.data) {
    return {
      valid: false,
      reason: USER_ACCESS_REASONS.NOT_FOUND,
      internalDetail: userResult.error || 'user not found in RTDB',
    }
  }

  return evaluateUserSessionFromRTDB(userResult.data)
}
